import { escapeHtml } from "../util/html";

/** 互动页「古典名画对对配」微信小程序说明（纯文案，不含 HTML） */
export const DESC_PAINTING_MATCH_MINI =
  "一款艺术工具类小程序，通过行走配对驻足观赏等形式，帮助用户学习世界名画知识。包含世界著名绘画大师的 60 余幅经典作品。8 关难度适中，寓教于乐，适合全年龄段用户体验古典艺术的魅力。所有名画均为公有领域作品，无版权问题。";

/** 互动页「古典音乐线条」微信小程序说明（纯文案，不含 HTML） */
export const DESC_MUSIC_LINES_MINI =
  "古典音乐线条是一款节奏跑酷小程序：五线谱号沿着音乐节奏轨道前进，用户通过换档与跳跃越过断档，在古典乐曲播放时间内抵达终点即可过关。操作单点即可完成，无对战、无内购诱导，适合碎片时间放松，兼具古典乐查询欣赏与手眼协调趣味。";

/** 互动页「诗词飞花对对配」微信小程序说明（纯文案，不含 HTML） */
export const DESC_POETRY_FEIHUA_MINI =
  "诗词飞花对对配：每日盲盒、无尽飞花令、顶针飞花接龙与对对配。收录唐诗宋词名句，可查古诗意思，可读大唐诗人与大宋词人列传。适合背古诗与飞花令入门。";

/** 官网 H5 诗词专区路径（静态页，便于 GEO / 搜索收录） */
export const POETRY_HUB_PATH = "/poetry/";

/** 官网 H5「古典名画对对配」权威页（GEO） */
export const PAINTING_MATCH_HUB_PATH = "/painting-match/";

/** 名画小程序引导短句（站内多处复用） */
export const CTA_PAINTING_MATCH =
  "想动手认画？请在微信搜索小程序「古典名画对对配」；介绍见官网专区。";

export function wechatOpenButtonHtml(openLink: string): string {
  const u = openLink.trim();
  if (!u) {
    return `<p class="section-sub" style="margin-top:1rem">请在微信中搜索并打开对应小程序进行游玩。</p>`;
  }
  return `<p class="wechat-mini-cta" style="margin-top:1rem">
    <a class="pill-btn pill-btn-link" href="${escapeHtml(u)}" target="_blank" rel="noopener noreferrer">打开微信小程序</a>
  </p>`;
}

/** 导向古典名画对对配的站内引导块 */
export function paintingMatchPromoHtml(opts?: { compact?: boolean }): string {
  const compact = opts?.compact === true;
  return `
    <aside class="mini-promo" aria-label="古典名画对对配">
      <p class="mini-promo-title">微信小程序 · 古典名画对对配</p>
      <p class="mini-promo-body">${
        compact
          ? "60 余幅公有领域名画 · 8 关配对学习。微信搜索即可打开。"
          : escapeHtml(DESC_PAINTING_MATCH_MINI)
      }</p>
      <p class="mini-promo-actions">
        <a class="pill-btn pill-btn-link" href="${PAINTING_MATCH_HUB_PATH}">查看介绍专区 →</a>
        <a class="text-link" href="/games#painting-match-title">互动页入口</a>
      </p>
    </aside>
  `;
}
